import React from 'react';
import Reveal from './Reveal';
import EditableText from './EditableText';
import { resolveHomeIcon } from '../lib/homeIcons';

const StatsBand = ({ stats }) => (
  <section className="relative border-y border-slate-200 bg-slate-50 px-4 py-10 sm:py-12">
    <div className="relative mx-auto max-w-7xl">
      <div className="grid grid-cols-2 gap-8 lg:grid-cols-4 lg:gap-6">
        {stats.map((stat, i) => {
          const StatIcon = stat.icon ? resolveHomeIcon(stat.icon) : null;
          const n = i + 1;
          return (
            <Reveal key={stat.label} animation="fade-up" delay={i * 45}>
              <div className="text-center">
                <div className="mb-1.5 flex items-center justify-center gap-2">
                  {StatIcon && (
                    <StatIcon
                      className={`h-4 w-4 ${i % 2 === 1 ? 'text-[#c47a0a]' : 'text-[#3a00e0]/80'}`}
                      strokeWidth={1.75}
                      aria-hidden="true"
                    />
                  )}
                  <span className="text-3xl font-bold tracking-tight text-gradient-brand sm:text-[2.15rem]">
                    {stat.value}
                  </span>
                </div>
                <EditableText
                  editKey={`home.stats.${n}.label`}
                  defaultValue={stat.label}
                  as="p"
                  className="text-sm text-slate-600"
                />
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default StatsBand;
